/**
 * pcOpts = {
 *  DISCOUNTCOUPON: '#order-create-coupon',
 *  OLDMONEYDOM: '.origin-amount',
 *  FREIGHTDOM: '.ship',
 *  PAYNEWDPM: '.total-amount'
 *  ORIGINDOM: '.detail'
 * }
 * phoneOpts = {
 *  DISCOUNTCOUPON: '.table-view-cell.table-view-cell-arr.order-coupon',
 *  OLDMONEYDOM: '.table-view-cell.table-view-cell-noborder',
 *  ORIGINDOM: '.table-view-cell.table-view-cell-noborder',
 *  CREATEORDERBUTTON: '.create-order-amount-wrap span'
 * }
 */
function modifyByEquipment (pcOpts, phoneOpts, bargainAmount) {
  if (isPcVisit()) {
    modifyPcOrderList(pcOpts, bargainAmount)
  } else {
    modifyPhoneOrderList(phoneOpts, bargainAmount)
  }
}

/**
 * 根据dom判断当前提交订单页是否是pc端
 */
function isPcVisit () {
  if (document.querySelector('.detail')) {
    return true
  } else {
    return false
  }
}

/**
 * 修改phone下单列表dom
 */
function modifyPhoneOrderList (phoneOpts, bargainAmount) {
  // 不允许使用优惠券
  let discountCoupon = document.querySelector(phoneOpts.DISCOUNTCOUPON)
  discountCoupon.style.display = 'none'
  //  获取商品金额总计
  let moneyArray = Array
    .prototype
    .slice
    .call(document.querySelectorAll(phoneOpts.OLDMONEYDOM), 0)
  let oldMoneyDom = moneyArray[0]
  let oldMoneyLastDom = oldMoneyDom.lastElementChild
  let oldMoneyLastDomTextContent = oldMoneyLastDom.textContent
  let oldMoney = oldMoneyLastDomTextContent.split('¥')[1] - 0

  //  商品金额总计newDom
  let oldMoneyNewDom = moneyArray[0].cloneNode(true)
  oldMoneyNewDom.firstElementChild.textContent = `商品金额总计`
  oldMoneyNewDom.lastElementChild.textContent = `¥${oldMoney.toFixed(2)}`

  //  获取运费总计
  let freightDom = moneyArray[1]
  let freightLastDom = freightDom.lastElementChild
  let freightLastDomTextContent = freightLastDom.textContent
  let freight = freightLastDomTextContent.split('¥')[1] - 0

  //  运费总计newDom
  let freightNewDom = moneyArray[1].cloneNode(true)
  freightNewDom.firstElementChild.textContent = `运费总计`
  freightNewDom.lastElementChild.textContent = `¥${(freight + 1e-6).toFixed(2)}`

  //  应付总额newDom
  let payNewDom = moneyArray[moneyArray.length - 1].cloneNode(true)
  let payNew = ((freight * 100 + bargainAmount * 100) / 100 + 1e-6).toFixed(2)
  payNewDom.firstElementChild.textContent = `应付总额`
  payNewDom.lastElementChild.textContent = `¥${payNew}`

  //  砍价活动优惠
  let bargainDom = moneyArray[1].cloneNode(true)
  let discount = ((oldMoney * 100 + freight * 100 - payNew * 100) / 100 + 1e-6).toFixed(2)
  bargainDom.firstElementChild.textContent = `砍价活动优惠`
  bargainDom.lastElementChild.textContent = `¥${discount}`

  //  原有dom全部隐藏
  for (const item of moneyArray) {
    item.style.display = 'none'
  }

  //  插入ul中
  let moneyulDom = document.querySelector(phoneOpts.ORIGINDOM)
  moneyulDom.appendChild(oldMoneyNewDom)
  moneyulDom.appendChild(freightNewDom)
  moneyulDom.appendChild(bargainDom)
  moneyulDom.appendChild(payNewDom)

  //  修改提交订单dom价格
  document.querySelector(phoneOpts.CREATEORDERBUTTON).textContent = `¥${payNew}`
}

/**
 * 修改pc端下单列表dom
 */
function modifyPcOrderList (pcOpts, bargainAmount) {
  // 不允许使用优惠券
  let discountCoupon = document.querySelector(pcOpts.DISCOUNTCOUPON)
  discountCoupon.style.display = 'none'
  //  获取商品金额总计
  let oldMoneyDom = document.querySelector(pcOpts.OLDMONEYDOM)
  let oldMoneyLastDom = oldMoneyDom.lastElementChild
  let oldMoneyLastDomTextContent = oldMoneyLastDom.textContent
  let oldMoney = oldMoneyLastDomTextContent.split('¥')[1] - 0

  //  商品金额总计newDom
  let oldMoneyNewDom = oldMoneyDom.cloneNode(true)
  oldMoneyNewDom.firstElementChild.textContent = `商品金额总计`
  oldMoneyNewDom.lastElementChild.textContent = `¥${oldMoney.toFixed(2)}`

  //  获取运费总计
  let freightDom = document.querySelector(pcOpts.FREIGHTDOM)
  let freightLastDom = freightDom.lastElementChild
  let freightLastDomTextContent = freightLastDom.textContent
  let freight = freightLastDomTextContent.split('¥')[1] - 0

  //  运费总计newDom
  let freightNewDom = freightDom.cloneNode(true)
  freightNewDom.firstElementChild.textContent = `运费总计`
  freightNewDom.lastElementChild.textContent = `¥${freight.toFixed(2)}`

  //  如果砍掉的钱大于商品价格，砍掉金额newDom
  let bargainDom = oldMoneyDom.cloneNode(true)
  bargainDom.firstElementChild.textContent = `砍价活动优惠`
  bargainDom.lastElementChild.textContent = `¥${bargainAmount}`

  //  应付总额newDom
  let payNew = ((oldMoney - 0) + (freight - 0) - (bargainAmount - 0) + 1e-6).toFixed(2)
  let payNewDom = document.querySelector(pcOpts.PAYNEWDPM).cloneNode(true)
  payNewDom.firstElementChild.textContent = `应付总额`
  if (payNew < 0) {
    payNew = 0
  }
  payNewDom.lastElementChild.textContent = `¥${(payNew + 1e-6).toFixed(2)}`

  //  原有dom全部隐藏
  let moneyArray = Array.from(document.querySelector(pcOpts.ORIGINDOM).children)
  for (const item of moneyArray) {
    item.style.display = 'none'
  }

  //  插入div中
  let moneyDivDom = document.querySelector(pcOpts.ORIGINDOM)
  moneyDivDom.appendChild(oldMoneyNewDom)
  moneyDivDom.appendChild(freightNewDom)
  moneyDivDom.appendChild(bargainDom)
  moneyDivDom.appendChild(payNewDom)
}

export {modifyByEquipment}



// WEBPACK FOOTER //
// ./src/common/util/modifyUIOfSubmitOrder.js